import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { AnalyticsContainer } from 'js/analytics';
import {
  AutotestAnalyticsProvider,
  resolveSurfaces,
} from 'js/analytics/autotest/AutotestAnalytics';
import 'js/i18n/translations/analytics_dashboard';
import renderOnsitePing from 'js/onsite_pings/onsite_pings.wjs';
import assignGlobal from 'js/utils/assign_global';
import registerForRails from 'js/utils/registerForRails';
import '../stylesheets/user_cards.scss';

import PaywallPage from 'js/analytics/pages/PaywallPage';
import ReadersExportModal from 'js/readers/ReadersExportModal';
import ProfileVisitorsExportModal from 'js/profile_visitors/ProfileVisitorsExportModal';

assignGlobal('Aedu', { renderOnsitePing: renderOnsitePing });

registerForRails(
  {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react/display-name
    Analytics: ({ params, autotestArm }) => (
      <Provider store={Aedu.ReduxStore}>
        <AutotestAnalyticsProvider value={resolveSurfaces(autotestArm)}>
          <BrowserRouter
            basename={`${encodeURIComponent(params.page_name)}/Analytics`}
          >
            <AnalyticsContainer />
          </BrowserRouter>
        </AutotestAnalyticsProvider>
      </Provider>
    ),
    PaywallPage,
    ReadersExportModal,
    ProfileVisitorsExportModal,
  },
  ['js/analytics'],
);
